import { render, staticRenderFns } from "./WarehouseItemsInOutReport.vue?vue&type=template&id=3b6a7956"
import script from "./WarehouseItemsInOutReport.vue?vue&type=script&lang=js"
export * from "./WarehouseItemsInOutReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports